import type { CanonicalEnvironment } from '../../shared/environment';

import { createContext, useContext } from 'react';

interface AceContext {
    accountId: string | null | undefined;
    isLoggedIn?: boolean | null;
    proctorGroups?: string | null;
    buildEnvironment?: CanonicalEnvironment | null;
}

export const AceContext = createContext<AceContext>({ accountId: '', isLoggedIn: null, buildEnvironment: null });
export const useAceContext = () => useContext(AceContext);
